import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { distinctUntilChanged, filter, map, tap } from 'rxjs';
import { AssetTreeItem } from '../model/asset-tree-node.model';
import { AssetExplorerService } from './asset-explorer.service';
import { AssetTreeUiService } from './asset-tree/asset-tree-ui.service';
import { AssetTreeComponent } from './asset-tree/asset-tree.component';

@UntilDestroy()
@Component({
  selector: 'exam-asset-explorer',
  templateUrl: './asset-explorer.component.html',
  styleUrls: ['./asset-explorer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [AssetExplorerService, AssetTreeUiService],
  host: { class: 'block flex-grow h-full' },
  imports: [AssetTreeComponent],
})
export class AssetExplorerComponent {
  constructor(private readonly assetExplorerService: AssetExplorerService) {
    this.emitActiveAssetOnChange().pipe(untilDestroyed(this)).subscribe();
  }

  @Input() set readonly(value: boolean) {
    this.assetExplorerService.setReadonlyMode(value);
  }

  @Output() clickedAsset = new EventEmitter<AssetTreeItem>();

  private emitActiveAssetOnChange() {
    return this.assetExplorerService.activeNode$.pipe(
      map((node) => node?.asset),
      distinctUntilChanged(),
      filter(Boolean),
      tap((asset) => this.clickedAsset.emit(asset)),
    );
  }
}
